import WeakDefaultMap from "../mem/weak-default-map";
import { AmbientLight, DirectionalLight, HemisphereLight, Object3D, Sphere } from "three";
import { DirectionalLightingViewConfig } from "./views-config";
import { Room } from "../domain";
import { getRoomBoundingSphere, updateShadowCameraBounds } from "../view3d/optimize-directional-shadow";
import { relativeDirectionalPosition } from "../view3d/directional-position";
import blackbody from "../color/blackbody";

export class DirectionalLightingView extends Object3D {
    main: DirectionalLight;
    hemi: HemisphereLight;
    ambient: AmbientLight;
}

const boundingSphere = new Sphere();

const cache = new WeakDefaultMap<Room, DirectionalLightingView>(() => {
    const
        view = new DirectionalLightingView(),
        mainLight = view.main = new DirectionalLight();

    view.name = 'DirectionalLightingView';

    view.add(mainLight);

    view.main.castShadow = true;

    view.main.intensity = 1;
    view.main.shadow.camera.near = 1;
    view.main.shadow.camera.far = 350;
    view.main.shadow.camera.right = 300;
    view.main.shadow.camera.left = -300;
    view.main.shadow.camera.top = 300;
    view.main.shadow.camera.bottom = -300;
    view.main.shadow.mapSize.width = 4096;
    view.main.shadow.mapSize.height = 4096;

    return view;
});

export const get = cache.get;

export const update = (room: Room, config: DirectionalLightingViewConfig) => {
    const view = get(room);

    view.main.target.position.copy(boundingSphere.center);
    relativeDirectionalPosition(
        view.main.position,
        boundingSphere.center,
        config.alt,
        config.az,
        boundingSphere.radius);
    view.main.userData.cpsMainLightAlt = config.alt;
    view.main.userData.cpsMainLightAz = config.az;

    // Update everything after it's all been recalculated
    view.main.shadow.camera.updateWorldMatrix(true, false);
    view.main.target.updateWorldMatrix(true, false);

    blackbody(config.temperature, view.main.color);
    view.main.userData.cpsMainLightColor = view.main.color.getHexString();
}

export const optimize = (room: Room) => {
    const view = get(room);
    getRoomBoundingSphere(room.walls, boundingSphere);
    updateShadowCameraBounds(view.main, boundingSphere);

    // DEBUG
//    view.add(new CameraHelper(view.main.shadow.camera));
//    const center = new ThreeAxisHelper();
//    center.position.copy(boundingSphere.center);
//    view.add(center);
//
//    const lightPos = new ThreeAxisHelper();
//    lightPos.position.copy(view.main.position);
//    view.add(lightPos);
}
